var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("GetFormField")
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("get.code")) + ":")]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("get.description1")) + ":")]),
                  _vm._v(" " + _vm._s(_vm.rowData.Description1))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("get.status")) + ":")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId === 2
                          ? _vm.$t("insert.passive")
                          : _vm.$t("insert.active")
                      )
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.Customer"), active: "" }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DocumentDate,
                                "date",
                                "get.BankTransaction.DocumentDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Bank,
                                "object",
                                "get.BankTransaction.Bank"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BankBranch,
                                "object",
                                "get.BankTransaction.BankBranch"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BankAccountNumber,
                                "text",
                                "get.BankTransaction.BankAccountNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Customer,
                                "object",
                                "get.BankTransaction.Customer"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CustomerBank,
                                "object",
                                "get.BankTransaction.CustomerBank"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CustomerBankBranch,
                                "object",
                                "get.BankTransaction.CustomerBankBranch"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.CustomerBankAccountNumber,
                                "text",
                                "get.BankTransaction.CustomerBankAccountNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DocumentNumber,
                                "text",
                                "get.BankTransaction.DocumentNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Currency,
                                "object",
                                "get.BankTransaction.Currency"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TransactionType,
                                "object",
                                "get.BankTransaction.TransactionType"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TransactionTotal,
                                "text",
                                "get.BankTransaction.TransactionTotal"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35155355", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35155355","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BankTransaction/get.vue
// module id = null
// module chunks = 